export default __webpack_public_path__ + "static/media/fastlane_detail6.ea3ddd6a.jpg";